import {
  SIMULATOR_LEFTEAR_SUBMIT,
  SIMULATOR_RIGHTEAR_SUBMIT,
} from '../actions/Simulator.js';

export default (state = {
  leftResult: [],
  rightResult: [],
}, action) => {
  switch (action.type) {
    case SIMULATOR_LEFTEAR_SUBMIT:
      return Object.assign({}, state, {
        leftResult: action.points,
      });

    case SIMULATOR_RIGHTEAR_SUBMIT:
      return Object.assign({}, state, {
        rightResult: action.points,
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/Simulator.js